"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SearchPreviewProduct = require("./SearchPreviewProduct");
Object.keys(_SearchPreviewProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchPreviewProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SearchPreviewProduct[key];
    }
  });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
//# sourceMappingURL=index.js.map